import {useMutation} from "react-query";
import {http} from "@firefly/fly-http";
import {Payment} from "../../typing";



interface CreateCoinPaymentInput {
    gameId: string;
    level: number;
}
export function useViewerCreateCoinPaymentMutation() {

    return useMutation<Payment, any, CreateCoinPaymentInput>({
        mutationFn: (variables: CreateCoinPaymentInput) => {
            return http.post(`/api/wangame/viewer/coin-payment`, variables)
        },
        onError: () => {

        }
    })
}